{
  "name": "surveyor",
  "version": "0.0.1",
  "private": true,
  "engines": {
    "node": ">=16"
  },
  "type": "commonjs",
  "scripts": {
    "ci": "npm run prettier:check && npm test:ci",
    "clean": "npx rimraf dist/*",
    "tsc": "tsc",
    "build": "npm i && npm run clean && npm run tsc && npm run build:app",
    "build:app": "npx parcel build ./app/main.tsx --dist-dir ./public",
    "server": "node dist/index.js",
    "worker": "node dist/worker.js",
    "postbuild": "cp ./package.json ./package-lock.json ./dist/ && cd dist && npm install --only=production",
    "start": "npm run dev:server",
    "dev:server": "npm run build:app && ts-node-dev --respawn --watch ./src -- ./src/index.ts",
    "test": "tape -r ts-node/register ./tests/**/*.ts",
    "test:ci": "tape -r ts-node/register ./tests/**/*.ts | tap-xunit",
    "test:watch": "tape-watch -r ts-node/register ./tests/**/*.ts",
    "prettier": "prettier --write .",
    "prettier:check": "prettier --check .",
    "watch": "ts-node-script scripts/watch-code.ts"
  },
  "dependencies": {
    "@cryptovoxels/app-basics": "^3.0.3",
    "@types/cors": "^2.8.12",
    "@types/jsonwebtoken": "^8.5.9",
    "@types/express": "^4.17.14",
    "@types/node": "^18.11.9",
    "@types/pg": "^8.6.5",
    "@parcel/transformer-typescript-tsc": "^2.8.0",
    "cors": "^2.8.5",
    "dotenv": "^16.0.3",
    "ethers": "5.7.1",
    "jsonwebtoken": "^8.5.1",
    "parcel": "^2.8.0",
    "preact": "^10.11.2",
    "preact-render-to-string": "^5.2.6",
    "rimraf": "^3.0.2",
    "typescript": "^4.8.4"
  },
  "devDependencies": {
    "@types/rimraf": "^3.0.2",
    "@types/tape": "^4.13.2",
    "prettier": "^2.7.1",
    "tap-xunit": "^2.4.1",
    "tape": "^5.6.1",
    "ts-node-dev": "^2.0.0"
  },
  "targets": {
    "app": {
      "context": "browser",
      "engines": {
        "browsers": "> 0.25%"
      },
      "isLibrary": false
    }
  }
}